import request from './http.js';
import {basic} from './config.js';
console.log('basic===>',basic)
export const regrApi = (data) => request.post('/api/user/register', data); // 注册
export const sendSmsApi = (data) => request.post('/api/sms/send', data); // 发送短信
export const mobileloginApi = (data) => request.post('/api/user/mobilelogin', data); // 手机验证码登录
export const loginApi = (data) => request.post('/api/user/login', data); // 身份证密码登录
export const logoutApi = (data) => request.post('/api/user/logout', data); // 退出登录

export const changepwdApi = (data) => request.post('/api/user/changepwd', data); // 修改密码



export const zpggApi = (data) => request.post('/api/index/zpgg', data); // 招考公告列表
export const zpggDetailApi = (data) => request.post('/api/index/zpgg_detail', data); // 招考公告-详情
export const joblistApi = (data) => request.post('/api/index/joblist', data); // 招考公告-去报名-工作列表
export const checkBaomingApi = (data) => request.post('/api/index/check_baomingv2', data); // 招考公告-报名信息检测
export const bkxxApi = (data) => request.post('/api/index/bkxx', data); // 填写报考信息
export const bcbkxxApi = (data) => request.post('/api/index/bcbkxx', data); // 上传资料及附件-提交报名
export const baomingUpdateApi = (data) => request.post('/api/index/baoming_update', data); // 修改报名
export const baomingrenshuApi = (data) => request.post('/api/index/baomingrenshu', data); // 报名人数-按钮

export const gggsListApi = (data) => request.post('/api/index/gggs_list', data); // 公告公示列表
export const gggsDetailApi = (data) => request.post('/api/index/gggs_detail', data); // 公告公示详情
export const cjwtListApi = (data) => request.post('/api/index/cjwt_list', data); // 常见问题-列表
export const cjwtDetailApi = (data) => request.post('/api/index/cjwt_detail', data); // 常见问题-详情


export const cjcxApi = (data) => request.post('/api/index/cjcx', data); // 成绩查询
export const baominglcApi = (data) => request.post('/api/index/baominglc', data); // 报名流程
export const getAreaTreeApi = (data) => request.post('/api/index/getAreaTree', data); // 省市区


export const jianliApi = (data) => request.post('/api/index/jianli', data); // 更新/新增简历
export const mybaomingApi = (data) => request.post('/api/index/mybaoming', data); // 我的报名
export const resumeApi = (data) => request.post('/api/index/resume', data); // 简历详情
export const getUserInfoApi = (data) => request.post('/api/user/get_user_info', data); // 获取用户信息
export const zkzkApi = (data) => request.post('/api/index/zkzk', data); // 打印准考证

export const forgetpwdApi = (data) => request.post('/api/user/forgetpwd', data); // 忘记密码
export const pcconfigApi = (data) => request.post('/api/index/pcconfig', data); // PC配置文件

export const richtextApi = (data) => request.post('/api/index/richtext', data); // type 1-服务协议 2-隐私政策, 3-支付协议
export const payApi = (data) => request.post('/api/pay/pay', data); // 拉起支付

export const baomingdetailApi = (data) => request.post('/api/index/baomingdetail', data); // 我的报名详情
// export const richtextApi = (data) => request.post('/api/index/richtext', data); // 预览准考证(PC端)
export const scanloginApi = (data) => request.post('/api/index/scanlogin', data); // PC微信扫码登录
export const wxscanbindApi = (data) => request.post('/api/index/wxscanbind', data); // PC微信扫码绑定
export const unbindApi = (data) => request.post('/api/index/unbind', data); // 微信小程序账号解绑
export const updateavatarApi = (data) => request.post('/api/index/updateavatar', data); // 更新头像








export const upUrlApi = basic.http+'/api/common/upload'; // 只需要地址的


export const getId = (key)=>{
  const url = window.location.search;
  const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
  const result = url.substr(1).match(reg);
  return result ? decodeURIComponent(result[2]) : null;
}

